import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {EaModelDraftDto} from "../../../../../model/dto/entity/ea-model-draft.dto";
import {ObjectIdentifierData} from "../../../../../../../core/shared/basic/object-identifier-data";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'ea-project-model-drafts-tab',
    templateUrl: './ea-project-model-drafts-tab.component.html',
    standalone: false
})
export class EaProjectModelDraftsTabComponent implements OnInit, OnChanges, OnDestroy {

    @Input() objectIdentifier: ObjectIdentifier;

    initialized: boolean;
    modelDraftsWidget: WidgetData;
    selectedModelDraft: EaModelDraftDto;
    selectedFieldId: number;

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent(): void {
        this.refreshWidgets();
        this.initialized = true;
    }

    refreshWidgets(): void {
        if (!this.objectIdentifier?.objectId) {
            return;
        }

        const filterCriteria = FilterCriteria.create('project', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        this.modelDraftsWidget = WidgetFactory.createWidgetTableEntityBasicQl(
            'ea.project.model.drafts.widget',
            'Model Drafts',
            'ea.EaModelDraft',
            [filterCriteria]
        );

        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'projectDtoId',
            fieldValue: this.objectIdentifier.objectId
        }];
        this.modelDraftsWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    handleModelDraftSelect(event: any): void {
        if (event?.data) {
            this.selectedModelDraft = event.data;
            this.selectedFieldId = null;
        }
    }

    handleFieldSelect(event: ObjectIdentifierData): void {
        this.selectedFieldId = event?.objectId;
    }

    handleFieldSaved(): void {
        // Field was saved in the editor widget, no action needed
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['objectIdentifier']) {
            this.refreshWidgets();
        }
    }

    ngOnDestroy(): void {
    }
}
